import { createUseStyles } from 'react-jss';

const styles = {
  modal: { boxSizing: 'border-box' },
  body: {
    font: {
      family: 'Lato, sans-serif',
    },
    width: '100%',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  title: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    marginBottom: '0.4rem',
    paddingBottom: '1.6rem',
    textAlign: 'center',
  },
  form: { padding: '0 2.4rem', position: 'relative' },
  formContent: { borderTop: '0.1rem solid #C1C7CD', paddingTop: '2rem' },
  formInput: { width: '100%', marginBottom: '3.6rem' },
  lowerFormInput: { marginBottom: '4rem' },
  footer: {
    margin: {
      top: '0.4rem',
      bottom: '4rem',
    },
    padding: { top: '4rem' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '0.1rem solid #C1C7CD',
  },
  actionsBlock: {
    margin: [0],
    width: '42.4rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  editRecordsButton: {
    minWidth: 'unset',
    padding: 0,
    font: {
      weight: 600,
      size: '1.6rem',
      lineHeight: '2.24rem',
      style: 'italic',
    },
  },
  toastMessage: {
    width: '80%',
    left: '10%',
    right: '20%',
    boxSizing: 'border-box',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
